// extracted by mini-css-extract-plugin
export default {"wingContainer":"WingSettings_wingContainer__1jSuw","wingWrapper":"WingSettings_wingWrapper__1EhbV"};